<template>
  <div class="col-sm-4">
    <div class="panel-content-inner platform-background rental-parameter-item height-100-p">
      <div class="panel-header text-align-center">
        <h4 class="inner-title">
          {{ $t('account.settings.user_platforms_section.deposit_confirmed_platforms_title') }}
        </h4>
      </div>
      <div class="panel-content form-group show m-t-25">
        <ul class="checkbox-custom m-l-30 checkbox-primary">
          <li class="checkbox-custom checkbox-primary" v-for="(value, key) in platforms">
            <input
              type="checkbox"
              :id="`platform-${value.id}`"
              :checked="isPlatformSelected(key)"
              @change="changeSelectedDepositPlatforms(key)"
            >
            <label :for="`platform-${value.id}`">{{ value.toUpperCase() }}</label>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "depositAutoConfirmedPlatforms",
        props: ['platforms', 'depositAutoConfirmPlatforms'],
        methods: {
          isPlatformSelected(platFormId) {
            if (platFormId) {
              return !!this.depositAutoConfirmPlatforms.find(platform => platFormId.toString() === platform.toString());
            }
            return false;
          },
          changeSelectedDepositPlatforms(platFormId) {
            if (platFormId) {
              this.$emit('updateSelectedDepositPlatforms', platFormId);
            }
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// depositAutoConfirmedPlatforms.vue?54ab3cb4